module.exports = __webpack_public_path__ + "portal/assets/img/logo.5aa75e27.svg";